import { create } from 'zustand';

import { DocumentMappingFilters } from '@/data/models/documentMapping.interface';
import { Platform } from '@/data/models/platform.interface';

interface DocumentMappingSelectionState {
  prefilledPlatform: Platform | null;
  prefilledFilters: DocumentMappingFilters | null;
  prefilledDocumentMappingPlatform: string | null;
  currentPlatform: Platform | null;
  currentFilters: DocumentMappingFilters | null;
  currentDocumentMappingPlatform: string | null;
  setPrefilledSelection: (
    _platform: Platform | null,
    _filters: DocumentMappingFilters | null,
  ) => void;
  setPrefilledDocumentMappingPlatform: (_platform: string | null) => void;
  clearPrefilledSelection: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _filters: DocumentMappingFilters | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const useDocumentMappingSelectionStore = create<DocumentMappingSelectionState>(
  (set) => ({
    prefilledPlatform: null,
    prefilledFilters: null,
    prefilledDocumentMappingPlatform: null,
    currentPlatform: null,
    currentFilters: null,
    currentDocumentMappingPlatform: null,

    setPrefilledSelection: (
      platform: Platform | null,
      filters: DocumentMappingFilters | null,
    ) => {
      set({
        prefilledPlatform: platform,
        prefilledFilters: filters,
      });
    },

    setPrefilledDocumentMappingPlatform: (platform: string | null) => {
      set({ prefilledDocumentMappingPlatform: platform });
    },

    clearPrefilledSelection: () => {
      set({
        prefilledPlatform: null,
        prefilledFilters: null,
        prefilledDocumentMappingPlatform: null,
      });
    },

    setCurrentSelection: (
      platform: Platform | null,
      filters: DocumentMappingFilters | null,
    ) => {
      set({
        currentPlatform: platform,
        currentFilters: filters,
      });
    },

    clearCurrentSelection: () => {
      set({
        currentPlatform: null,
        currentFilters: null,
        currentDocumentMappingPlatform: null,
      });
    },
  }),
);

export default useDocumentMappingSelectionStore;
